export type AdminTone = "neutral" | "accent" | "success" | "warning" | "danger";

export const adminToneClasses: Record<AdminTone, string> = {
  neutral: "bg-gray-100 text-gray-600",
  accent: "bg-whatsapp-light text-whatsapp",
  success: "bg-green-50 text-green-700",
  warning: "bg-amber-50 text-amber-700",
  danger: "bg-red-50 text-red-700",
};

export const adminBadgeClasses: Record<AdminTone, string> = {
  neutral: "border-gray-200 bg-gray-100 text-gray-700",
  accent: "border-whatsapp/20 bg-whatsapp-light text-whatsapp",
  success: "border-green-200 bg-green-50 text-green-700",
  warning: "border-amber-200 bg-amber-50 text-amber-700",
  danger: "border-red-200 bg-red-50 text-red-700",
};
